import "../../styles/landing-pages/embedded.scss";

const { page_name } = window.tg;

if ( page_name === 'landing-pages.signup' ) {
    if (document.querySelector(".onboarding-swiper-ls")) {
        bind_swiper(".onboarding-swiper-ls");
    }
}

if ( page_name === 'landing-pages.login' ) {
    document.querySelector('input[type="email"]').onclick = function() {
        this.scrollIntoView({ behavior: "smooth", block: "center" })
    }
}
